import React, { Component } from 'react';

export default class Homecards extends Component {
  render() {
    return (
      <main>
        <div className="meet-squeeze__row">
          <article className="meet-squeeze__col">
            <i className="icon-home icon-home--iphone-smiley" />
            <h3 className="meet-squeeze__col-title">
              It’s <span>App</span>-solutely<br />Stress-free
            </h3>
            <p className="meet-squeeze__col-copy">
              Book, pay and tip on the app. So after your massage, you can just
              float on out.
            </p>
          </article>
          <article className="meet-squeeze__col">
            <i className="icon-home icon-home--aromatherapy" />
            <h3 className="meet-squeeze__col-title">
              <span>Extras</span> Don’t <br />Cost Extra
            </h3>
            <p className="meet-squeeze__col-copy">
              Each massage includes your choice of deep tissue, heat therapy,
              percussion therapy and aromatherapy at no additional charge.
            </p>
          </article>
          <article className="meet-squeeze__col">
            <i className="icon-home icon-home--preferences" />
            <h3 className="meet-squeeze__col-title">
              You Might Think <br /> <span>We’re Mind Readers.</span>
            </h3>
            <p className="meet-squeeze__col-copy">
              But we’re not. We just save your massage preferences to your
              profile, so your therapist knows exactly what you want, each and
              every time.
            </p>
          </article>
        </div>
      </main>
    );
  }
}
